// Structured logging utility for frontend
// Only logs in development mode to avoid console output in production

type LogLevel = 'debug' | 'info' | 'warn' | 'error';

interface LogContext {
  component?: string;
  error?: Error;
  [key: string]: unknown;
}

class Logger {
  private isDevelopment = import.meta.env.DEV;

  private log(level: LogLevel, message: string, context?: LogContext) {
    if (!this.isDevelopment) {
      return;
    }

    const timestamp = new Date().toISOString();
    const logData = {
      timestamp,
      level,
      message,
      ...context,
    };

    switch (level) {
      case 'debug':
        // eslint-disable-next-line no-console
        console.debug('[DEBUG]', message, logData);
        break;
      case 'info':
        // eslint-disable-next-line no-console
        console.info('[INFO]', message, logData);
        break;
      case 'warn':
        // eslint-disable-next-line no-console
        console.warn('[WARN]', message, logData);
        break;
      case 'error':
        // eslint-disable-next-line no-console
        console.error('[ERROR]', message, logData);
        break;
    }
  }

  debug(message: string, context?: LogContext) {
    this.log('debug', message, context);
  }

  info(message: string, context?: LogContext) {
    this.log('info', message, context);
  }

  warn(message: string, context?: LogContext) {
    this.log('warn', message, context);
  }

  error(message: string, context?: LogContext) {
    this.log('error', message, context);
  }
}

export const logger = new Logger();
export default logger;
